import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect old org-scoped helpdesk URLs to unified helpdesk
export const Route = createFileRoute("/org/$orgSlug/helpdesk")({
  beforeLoad: () => {
    throw redirect({ to: "/helpdesk" });
  },
});
